const useOtpTypes = () => {
  const OTP_SUCCESS = "OTP_SUCCESS";

  return { OTP_SUCCESS };
};

export default useOtpTypes;
